import { Err, ResponseData } from 'types';

import { http } from '.';

export const createDebitor = async (payload) => {
  return await http.post<Err, ResponseData<1>>(
    `/Debitor/create/debitor`,
    payload
  );
};

export const createCreditor = async (payload) => {
  return await http.post<Err, ResponseData<1>>(
    `/Creditor/create/creditor`,
    payload
  );
};

export const getCreditors = async () => {
  return await http.get<Err, ResponseData<any>>(`/Creditor/GetCreditors`);
};
export const getDebitors = async () => {
  return await http.get<Err, ResponseData<any>>(`/Debitor/GetDebitors`);
};
export const getReportsPermissions = async () => {
  return await http.get<Err, ResponseData<any>>(`/Report/GetReports`);
};
export const getMyDebitors = async (
  pageSize: number,
  pageIndex: number,
  partnerName?: string
) => {
  const encodedName = partnerName ? encodeURIComponent(partnerName) : '';
  return await http.get<Err, ResponseData<any>>(
    `/Debitor/GetMyDebitors?PageIndex=${pageIndex}&PageSize=${pageSize}&partnerName=${encodedName}`
  );
};

export const getMyCreditors = async (
  pageSize: number,
  pageIndex: number,
  partnerName?: string
) => {
  const encodedName = partnerName ? encodeURIComponent(partnerName) : '';
  return await http.get<Err, ResponseData<any>>(
    `/Creditor/GetMyCreditors?pageSize=${pageSize}&pageIndex=${pageIndex}&partnerName=${encodedName}`
  );
};

export const getPartners = async () => {
  return await http.get<Err, ResponseData<any>>(`/Report/GetReportPartners`);
};
export const getPartnersReport = async () => {
  return await http.get<Err, ResponseData<any>>(`/Report/GetReportPartners`);
};
export const deleteDebitor = async (partnerId: number) => {
  return await http.delete<Err, ResponseData<boolean>>(
    `/Debitor/DeleteDebitorById?partnerId=${partnerId}`
  );
};
export const deleteCreditor = async (partnerId: number) => {
  return await http.delete<Err, ResponseData<boolean>>(
    `/Creditor/DeleteCreditorById?partnerId=${partnerId}`
  );
};

export const updateCreditor = async (payload) => {
  return await http.put<Err, ResponseData<1>>(
    `/Creditor/update/creditor`,
    payload
  );
};

export const updateDebitor = async (payload) => {
  return await http.put<Err, ResponseData<1>>(
    `/Debitor/update/debitor`,
    payload
  );
};

export const getCreditorDataById = async (partnerId: number) => {
  return await http.get<Err, ResponseData<any>>(
    `Creditor/GetContractDataByCreditorId/${partnerId}`
  );
};
export const getDebitorDataById = async (partnerId: number) => {
  return await http.get<Err, ResponseData<any>>(
    `Debitor/GetContractDataByDebitorId/${partnerId}`
  );
};

export const getDebitorById = async (partnerId: number) => {
  return await http.get<Err, ResponseData<any>>(
    `Partners/GetDebitorById/${partnerId}`
  );
};

export const getCreditorrById = async (partnerId: number) => {
  return await http.get<Err, ResponseData<any>>(
    `Creditor/GetCreditorById?partnerId=${partnerId}`
  );
};
export const getDebitorrById = async (partnerId: number) => {
  return await http.get<Err, ResponseData<any>>(
    `Debitor/GetDebitorById?partnerId=${partnerId}`
  );
};
